import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3 sm:grid-cols-1" }

import { InputRow, Select } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { optionsYesNo } from '@/utils/form';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DataFieldForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "data_field_name",
      label: "system.data_field_name"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Input), {
          id: "data_field_name",
          modelValue: _ctx.form.data_field_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.data_field_name) = $event)),
          placeholder: _ctx.$t('system.data_field_name')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "data_field_status",
      label: "system.data_field_approve"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          modelValue: _ctx.form.data_field_status,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.data_field_status) = $event)),
          options: _unref(optionsYesNo),
          translate: true
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "data_field_group",
      label: "system.data_fields.group"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          modelValue: _ctx.form.data_field_group,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.data_field_group) = $event)),
          options: [
                    { value: 'bookkeeping_status', label: 'system.bookkeeping_status' },
                    { value: 'report_status', label: 'system.report_status' },
                    { value: 'vat_status', label: 'system.vat_status' },
                    { value: 'pbc_status', label: 'system.pbc_status' },
                    { value: 'annual_report', label: 'system.annual_report' },
                ],
          translate: true
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "data_field_color",
      label: "system.data_fields.color"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          modelValue: _ctx.form.data_field_color,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.data_field_color) = $event)),
          options: [
                    { value: 'yellow', label: 'system.data_field_colors.yellow' },
                    { value: 'red', label: 'system.data_field_colors.red' },
                    { value: 'green', label: 'system.data_field_colors.green' },
                    { value: 'blue', label: 'system.data_field_colors.blue' },
                    { value: 'baby_blue', label: 'system.data_field_colors.baby_blue' },
                    { value: 'bright_yellow', label: 'system.data_field_colors.bright_yellow' },
                ],
          translate: true
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})